module.exports = __webpack_public_path__ + "img/easy_start_icon.0e639028.png";